import { z } from "zod";
import type { FirebaseTimestamp } from "./FirebaseTimestamp";

export const ReservationStatus = z.enum([
    "unselected",
    "prebooked",
    "confirmed",
    "cancelled",
]);

export type ReservationStatus = z.infer<typeof ReservationStatus>;

export const ReservationStatusToTimestampMap: Record<
    ReservationStatus,
    string | undefined
> = {
    unselected: undefined,
    prebooked: "prebookedAt",
    confirmed: "confirmedAt",
    cancelled: "cancelledAt",
};

export const ReservationStatusMap: Record<ReservationStatus, string> = {
    unselected: "Not booked yet",
    prebooked: "Pre-booked",
    confirmed: "Confirmed",
    cancelled: "Cancelled",
};

export function displayReservationStatus(status: ReservationStatus | undefined | null) {
    if (!status) return "Not booked yet";
    if (status === "unselected") return "Not booked yet";
    return ReservationStatusMap[status];
}

export type ReservationTimestamp = {
    timestamp: FirebaseTimestamp | null | undefined;
    timezone: string | null | undefined;
};
